/*
These values are collected from the Auth Service and MongoDB. These live as static files there and are expanded upon in downstream services like Security Service.
*/

export const enum OPT_INS {
  PACKAGE_SIZING = 'package-sizing-opt-in',
  EXCEPTION_MANAGEMENT = 'exceptions-management-opt-in',
  DELIVERY_EXPERIENCE = 'delivery-experience-opt-in',
  PARTNER_CONFIGURATION_API = 'partner-configuration-api-opt-in',
  PARTNER_SIMULATION = 'partner-simulation-opt-in',
  CARRIER_SELECTION = 'carrier-selection-opt-in',
  DX_MULTI_CART_DELIVERY_ESTIMATE_API = 'dx-multi-cart-delivery-estimate-api',
  AT_LARGE_SHIPPING = 'at-large-shipping-opt-in',
  TRACKING = 'tracking-opt-in',
  SIMULATION_DEID_BACKFILLS = 'simulate-deid-backfills-opt-in',
  PARTNER_CONSOLE = 'partner-console-opt-in',
  FULFILLMENT_ENGINE = 'fulfillment-engine-opt-in',
  SUBSCRIPTIONS = 'subscriptions-opt-in',
  SHIPPING_LABEL_RETRIEVAL = 'shipping-label-retrieval-opt-in',
  REPORTING = 'reporting-opt-in',
  CARRIER_TRACKING_API = 'carrier-tracking-api-opt-in',
  CONSOLE_AI = 'console-ai-opt-in',
  RULES_AI = 'rules-ai-opt-in',
  EUROPE_DOMAIN_ACCESS = 'europe-domain-access-opt-in',
}
